export default __webpack_public_path__ + "static/media/Bg1.669e73a1.jpg";